module.exports = class CurrenciesFormCtrl
  submit: ->
    @onSubmit(currency: @currency)
